<template>
  <div class="mainbody" style="min-height: 40vw;">
   <div class="containerDiv"> 
      <div class="whiteBg" > 
        <div class="txtMd2"  >
          <div v-html="brief.content"></div>
          <!-- 河南于2013年7月18日开行首班中欧班列，是全国开行中欧班列较早的省份，班列开行先发优势突出。2014年5月10日，习近平总书记视察河南时提出“建成连通境内外，辐射东中西的物流通道枢纽，为丝绸之路经济带建设多作贡献”。十余年来，河南深度融入国家“一带一路”建设，准确把握国家对郑州集结中心“积极承接东部沿海地区转移货源”的功能定位，构建了成熟完善的中欧班列运营体系，货源集聚效应和枢纽集结功能日益凸显。
          累计开行1.5万列（截至2025年6月底），
          拓展形成了“25个境外直达站点、9个出入境口岸站”的国际物流网络和“1+N”境内外物流枢纽体系，境内服务半径超1500公里，境外服务覆盖欧盟、俄罗斯、中亚、东盟、日韩等40多个国家140多个城市，合作伙伴超8000家，班列呈现高频次常态化往返均衡开行状态，综合运营能力始终处于全国“第一方阵”。  -->
         
          <!-- <br /> -->
         <!-- <p  > 联系方式： 0371-55176895   0371-55176898</p> -->
      
        </div>
     
      
        <div class="rowImg0510" v-scroll-animate="'fly-in-left5'" >
          <span v-for="(item,index) in imgData.slice(0,4)" :key="index" >
            <img :src="urlBase+item"  />

          </span>
        
          <!-- <img src="../../assets/ywbkNew/0/a2.jpg" />
          <img src="../../assets/ywbkNew/0/a3.png" />
          <img src="../../assets/ywbkNew/0/a4.jpg" /> -->
        </div>
      </div>
      <div class="zoblLines" v-scroll-animate="'fly-in-right5'" > 
       <h3> 主营线路</h3>
        <ul>
          <li v-for="(item,index) in this.zhongouData.segmentsList" :key="index">
              <div><b>{{ item.names }}</b> </div>
              <div> {{ item.content }} </div>
          </li>
          <!-- <li>
              <div><b>俄线</b> </div>
              <div> 郑州--莫斯科 去程整柜/拼箱、俄线回程专列 </div>

          </li>
          <li>
              <div><b>亚线</b> </div>
              <div> 郑州--阿腾科里/多斯特克/阿拉木图/卡拉干达/塔什干/巴库等，去程整柜/亚线回程专列  </div>
          </li>
          <li>
              <div><b>东盟线路</b> </div>
              <div> 郑州--河内/胡志明，万象/琅勃拉邦/纳堆等，去回程整柜/包列 </div>
          </li> -->
        </ul>
        
         

      </div>

      <!-- <pianqu2 :zoneList="zoneList" /> -->
       <div class="painqu2Component"  >
         <h3>郑州国际陆港双片区</h3>
         <h5>枢纽集疏在港区、展示交易在经开</h5>

         <div class="pianqu2Div" id="targetPianqu"> 
          <el-row v-for="(item,index) in zoneList" :key="index">
                     
          <el-col :span="12" :xs="24">
            <img class="pianqu2Img" :src="urlBase+item.icon.split('|')[1]" />
          </el-col>
          <el-col :span="12" :xs="24" > 
            <h2>{{ item.names }}</h2>
            <p >{{ item.brief }}</p>
            <a  @click="goPianquDetail(item.content,item.namesenglish,item.names,item.photo)">详情</a>
          </el-col>
         </el-row>
 
         </div>

         
     </div>
      <!-- <pianqu2Detail :zoneList="zoneList" /> -->
  

      <div class="modules3Container1"  > 
           <div class="modules0 modules00" style="text-align: center;">
            <div class="title-with-lines">
              <div class="clipped-gradient-line0510 clipped-gradient-line10510"></div>
              <span class="title-text"><span>中欧班列(郑州)发展历程</span></span>
              <div class="clipped-gradient-line0510"></div>
            </div>
           
          </div>
           <timeLine :synopsisList="synopsisList" v-scroll-animate="'fly-in-right5'" />
 
       </div>
    </div>
   </div>
</template>

<script>
import API from '@/api/bsInfo'

import timeLine from '@/components/businessDetail/timeLine.vue'
import pianqu2 from '@/components/businessDetail/pianqu2.vue'

export default {
 components: {
  timeLine,
  pianqu2
 },
 data() {
   return {
    urlBase: process.env.VUE_APP_BASE_API,

    brief:{},
    zoneList:[],
    synopsisList:[],
    zhongouData:{},
   indexNum:null,
   indexNum1:null,
   imgData:[],
   datalist1:[
    {
      name:'国际货运代理服务'
    },
    {
      name:'多式联运运营服务'
    },
    {
      name:'国外物流业务服务'
    },
    {
      name:'物流技术装备服务'
    }
   ],
   datalist2:[
    {
      name:'供应链综合服务'
    },
    {
      name:'仓储配送一体化服务'
    },
    {
      name:'冷链物流服务'
    }
   ],
   
   }
 },
 props: {
   
 },
 mounted() {
     this.zhongoubanlieData();
     
     if(this.$route.query.dingwei == '1'){
        let objID='targetPianqu'
        const element = document.getElementById(objID);
        element.scrollIntoView({ 
          behavior: 'smooth', // 平滑滚动
          block: 'start'      // 对齐到顶部（可选：'center'/'end'）
        });
     }
   },
 methods: {
   goPianquDetail(contentMSg,namesenglish,names,photo){
       const encodedTitle = encodeURIComponent('中欧班列')
      this.$router.push({
        path: '/pianqu2Detail',
        query: {                     
          title: encodedTitle,
          namesenglish:namesenglish,
          names:names,
          contentMSg:contentMSg,
          photo:photo.substring(1,photo.length)
        }
      })
 
    },  

  getPlainText(htmlString) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString
      return tempDiv.textContent || tempDiv.innerText || ''
    },
   //获取中欧班列页面数据
   async zhongoubanlieData() {
      try {
        let objParams={
          catId:'f1c0af20344a413fb35498338645dccb'
        }
        const res = await API.zhongoubanlieData(objParams)
        
        this.$nextTick(()=>{
          this.zhongouData = res.data
          console.log('this.zhongouData=========================')
          console.log(this.zhongouData)
          this.zoneList=res.data.zoneList
          
          this.brief=res.data.brief
          this.brief['content1']=this.getPlainText(this.brief.content)
          this.imgData=(this.brief.photo.split('|')).splice(1,4);
          this.synopsisList=res.data.synopsisList
          console.log('获取成功', res.data.resultData)
        })
       
      } catch (error) {
        console.error('获取失败', error)
      }
    },
  loadMore() {
    let length0=this.timelineItems.length
    let lengthNum=lengthNum0+5
       this.timelineItems=this.timelineItems0.sclice(0,lengthNum)
    }
 },
}
</script>

<style lang="scss" scoped>

 .mainbody{
   width: 100%
   // background: #dde8f4;
   // margin-block: 100px;
   // background:url('../../assets/img3/gaikuang1/chanyepng.png');
 // background-size: 100% 100%;
 // .modules0{
 // 	width: 100%;
 // 	margin: 0 auto;
 // }
    
 }
 .containerDiv{
 width: 100%;
   // background: #dde8f4;
   // margin-block: 100px;
  //  background:url('../../assets/img3/gaikuang1/chanyepng.png');
//  background-size: 100% 100%;
 @media screen and (max-width: 768px) {
   background-size: auto 100%;
 }
 }
 
 .whiteBg{
   width: 100%;
   margin:0 auto;
   margin-bottom:12rem;
  //  margin-bottom: 5rem;
  //  padding:2rem 0;
   background:url('../../assets/ywbkNew/0/bg1.png');
    background-size: cover;
  //  background:linear-gradient(to bottom, rgba(252, 253, 253, 0), rgb(251, 252, 252,0.8))
  .txtMd2{
 
    width: 90%;
    margin:0 auto;
    padding-top:2rem;
    padding-left: 0;
    padding-right: 1rem;
     padding-bottom:11rem;
    color: #ffffff;
    
     /* 重置所有子元素 */
    & * {
      all: initial;
      font-family: inherit;
      font-size: inherit;
      color: inherit;

     
      text-indent:2rem;
      text-align: justify;
      line-height: 2rem;
    }
    div{
      p{
        background: red;

      }
    }
    
    
      // background-color: rgba(30, 30, 126, 0.5);  
    @media screen and (max-width: 768px) {
      width: 100%;
      margin-left:0;
      line-height: 2rem;
      padding: 3rem;
    }
    
  }

  .txtMd2 ::v-deep(*) {
    font-size: 1.0rem;
    line-height: 2rem !important;
  }
  .txtMd2 ::v-deep(p) {
     width: 100%;
     display: block;

    //  background: red;
  }
 } 
 .modules3Container{


  position: relative;
  width: 100%;
  .modules3Item{
 
  color: #333333;
 }

 }
 .modules3Container1{
  // width: 100%;
  // background:url('../../assets/ywbkNew/1/7.png');
  // background-size: cover;
  // min-height: 50vw;
  margin-top: 2rem;
  position: relative;
  width: 100%;
  padding-bottom: 6.25%; /* 16:9 比例 (9/16=0.5625) */
  background:url('../../assets/ywbkNew/0/bg2.png');
  background-size: cover;
  background-position: center;

 }
 .modules3Div{
   width: 90vw;
   margin:0 auto;
   padding:2rem 0;
 }
 .modules3Item{
  background: none;
  border: 1px solid #a3c9fa;
  color: #ffffff;
  padding: 4rem 0;
 }
 .modules3rowDiv{
  // padding-top:3rem;
 }
 .activeYwbkItem2{
  // background-color: rgba(249, 249, 251, 0.5);  
  background: #015293;

  
   .titleModule3item{
    font-size: 1.2rem;
    font-weight: bold;
    color: #ffffff;
   }
   li{
   img{
    filter: brightness(0) invert(1); /* 将图片变为白色 */
   }
   }
 }
 .modules3Div1{
  width: 100%;
  padding-left: 5%;
  color: #ffffff;
  // background: #ffffff;
  h5{
    font-size: 1.2rem;
    padding:2rem 0;
  }
  p{
    font-size: 1rem;
    line-height: 2rem;
  }
 }
 
 .el-timeline-item__tail{
  left:50%;
 }
 ::v-deep .el-timeline-item__node--normal{
  left: 50% !important;
  transform: translateX(-1.2rem);
 }
 .modules00 {
    padding:5rem 0;
}
 .modules00 *{
  color: #ffffff !important;
  .title-text{
    padding: 0 10px;
    font-size: 1.2rem;
    color: #ffffff;
    white-space: nowrap;
    span{
      font-size: 1.4rem;
    }
  }


.clipped-gradient-line0510 {
    display: inline-block;
    width: 10vw;
    height: 0.2rem;
    transform: translateY(-0.5rem);
    background: linear-gradient(to right,
            #ffffff,
            #fdfefea8,
            #fdfdfd24,
            #fafafb00);
}

@media screen and (max-width: 768px) {
    .clipped-gradient-line0510  {
        width: 2vw; 
        // 右侧
    }
    
}

.clipped-gradient-line10510 {
    transform: translateY(-0.5rem);
    display: inline-block;
    width: 10vw;
    height: 0.2rem;
    background: linear-gradient(to right,
            #fafafb00,
            #fdfdfd24,
            #fdfefea8,
            #ffffff,);
}

 }
 @media screen and (max-width: 768px) {
    
    .clipped-gradient-line10510 {
      width: 2vw;
       // 左侧
    }
}

 
 </style>